import React, { Component, Suspense } from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import routes from './routes';


import { UserProvider } from "./context/Admin/UserContext";
import { Acard_Provider } from './context/Sales/Acard_Context';
import { ScoreCardProvider } from './context/Sales/ScoreCardContext';
import { Address_Provider } from './context/Address/Address_Context';
import { OTP_Provider } from './context/Sales/OTP_Context';
import { DB_Provider } from './context/Sales/DB_Context';
import { Job_Provider } from './context/Sales/Job_Context';
import { Account_Provider } from './context/Sales/Account_Context';
import { Filekeep_Provider } from './context/Filekeep/Filekeep_Context';
import { Personal_Provider } from './context/Sales/Personal_Context';
import { DB_v2_Provider } from './context/Sales/DB_V2_Context';
import { Reservate_Provider } from './context/Sales/Reservate_Context';
import { SaleInfo_Provider } from './context/Sales/SaleInfo_Context';
import { TBR_Provider } from './context/Sales/TBR_Context';
import { MP_Provider } from './context/Sales/Mp_Context';
// ===================================================
import { Productlistbranch_Provider } from './context/Product/Productlistbranch_Context';
import { Productlistbybrand_Provider } from './context/Product/Productlistbybrand_Context';
import { ProductList_Provider } from "./context/Product/ProductList_Context";

import { Productdetailbyregister_Provider } from './context/Product/Productdetailbyregister_Context';
import { Product_Sold_Provider } from './context/Product/Product_Sold_Context';

import { Productlistbymodel_Provider } from './context/Product/Productlistbymodel_Context';
import { ProductSearch_Provider } from './context/Product/ProductSearch_Context';

import { Productcurrentstock_SurekProvider } from './context/Product/Productcurrentstock_SurekContext';
import { Productlistbybrand_SurekProvider } from './context/Product/Productlistbybrand_SurekContext';
import { Productlistbymodel_SurekProvider } from './context/Product/Productlistbymodel_SurekContext';
import { ProductSearch_surekProvider } from './context/Product/ProductSearch_surekContext';
import { Productdetailbyregister_SurekProvider } from './context/Product/Productdetailbyregister_SurekContext';
import { Productcurrentstock_Provider } from './context/Product/Productcurrentstock_Context';

import { ProductProvider } from './context/Product/ProductContext';
import { Product_NGC_Provider } from './context/Product/Product_NGC_Context';


class App extends Component {
  render() {
    return (
      <HashRouter>
        <UserProvider>
          <Acard_Provider>
            <ScoreCardProvider>
              <OTP_Provider>
                <Address_Provider>
                  <DB_Provider>
                    <Job_Provider>
                      <Account_Provider>
                        <Filekeep_Provider>
                          <Personal_Provider>
                            <DB_v2_Provider>
                              <Reservate_Provider>
                                <SaleInfo_Provider>
                                  <TBR_Provider>
                                    <MP_Provider>


                                      <Productlistbranch_Provider>
                                        <Productlistbybrand_Provider>
                                          <Productcurrentstock_Provider>


                                            <Productlistbymodel_Provider>
                                              <ProductSearch_Provider>
                                                <Productcurrentstock_SurekProvider>
                                                  <Productlistbybrand_SurekProvider>
                                                    <Productdetailbyregister_SurekProvider>
                                                      <ProductSearch_surekProvider>
                                                        <Productlistbymodel_SurekProvider>

                                                          <ProductList_Provider>
                                                            <Productdetailbyregister_Provider>
                                                              <Product_Sold_Provider>

                                                                <ProductProvider>
                                                                  <Product_NGC_Provider>




                                                                    <Suspense fallback={<div>Loading...</div>}>
                                                                      <Switch>
                                                                        {routes.map((route, idx) =>
                                                                          route.component ? (
                                                                            <Route
                                                                              key={idx}
                                                                              path={route.path}
                                                                              exact={route.exact}
                                                                              render={(props) => <route.component {...props} />}
                                                                            />
                                                                          ) : null
                                                                        )}
                                                                      </Switch>
                                                                    </Suspense>

                                                                  </Product_NGC_Provider>
                                                                </ProductProvider>

                                                              </Product_Sold_Provider>
                                                            </Productdetailbyregister_Provider>
                                                          </ProductList_Provider>

                                                        </Productlistbymodel_SurekProvider>
                                                      </ProductSearch_surekProvider>
                                                    </Productdetailbyregister_SurekProvider>
                                                  </Productlistbybrand_SurekProvider>
                                                </Productcurrentstock_SurekProvider>
                                              </ProductSearch_Provider>
                                            </Productlistbymodel_Provider>
                                          </Productcurrentstock_Provider>

                                        </Productlistbybrand_Provider>
                                      </Productlistbranch_Provider>


                                    </MP_Provider>
                                  </TBR_Provider>
                                </SaleInfo_Provider>
                              </Reservate_Provider>
                            </DB_v2_Provider>
                          </Personal_Provider>
                        </Filekeep_Provider>
                      </Account_Provider>
                    </Job_Provider>
                  </DB_Provider>
                </Address_Provider>
              </OTP_Provider>
            </ScoreCardProvider>
          </Acard_Provider>
        </UserProvider>
      </HashRouter>
    );
  }
}

export default App;
